import './AssignmentTable.scss'

import React, {Component} from 'react'
import Table from 'common/views/atoms/Table/Table'
import ReactTooltip from 'react-tooltip'
import cx from 'bem-classnames'
import moment from 'moment-timezone'
import { show as showModal } from 'redux-modal'
import ShowMore from 'react-show-more'
import ReferralNoteModal from 'broker/views/components/ReferralNoteModal'

import LeadTypeBadges from 'broker/views/components/LeadTypeBadges'


import {
  masqueradeAgent
} from 'broker/redux/account'

import {
  RELEASE_REASONS,
  SHORT_ASSIGNMENT_AGENT_STATUS,
  SHORT_ASSIGNMENT_AGENT_STATUS_LISTING,
  SHORT_ASSIGNMENT_AGENT_STATUS_LEASE,
  AGENT_OFFER_STATUS_SELLING,
  AGENT_OFFER_STATUS_LISTING,
  AGENT_CONTRACT_STATUS,
  AGENT_CONTRACT_STATUS_LEASE,
  BUYER_TYPE,
  LEAD_TYPE,
  DISPLAY_PRICE,
  LEAD_OWNER_TYPE,
  LEAD_OWNER_LABEL,
  LEAD_OWNER_COMMISSION_STATUS,
} from 'common/constants'

import { newlineToBreak, labelFor } from 'common/util/helper'

import { exportSearchFiltersForSegment } from 'broker/util/helper'

import { segmentEventTracker } from 'common/analytics'

import { AgentTerminated } from "common/views/components/AgentTerminated"

const classes = {
  name: 'Assignment__status',
  modifiers: SHORT_ASSIGNMENT_AGENT_STATUS.map(item => item.value),
}

class AssignmentTable extends Component {

  constructor(props) {
    super(props)
    this.handleEditClick = this.handleEditClick.bind(this)
    this.handleViewAgentClick = this.handleViewAgentClick.bind(this)
    this.handleClickForSegmentEvent = this.handleClickForSegmentEvent.bind(this)
  }

  handleEditClick(item) {
    this.props.dispatch(showModal('ReferralNoteModal', {
      item,
      onSave: () => {
        this.props.dispatch(this.props.fetch(this.state))
      }
    }))
  }

  handleViewAgentClick(item) {
    this.props.dispatch(masqueradeAgent(item.agent_id))
      .then(response => {
        window.open(
          response.url,
          '_blank'
        )
      })
  }

  handleClickForSegmentEvent = (item, eventName, otherSegmentProperties) => {
    const { activeFilters, filterTypeOptions } = this.props

    const baseSegmentProperties = {
      'transaction_agent_user_hash': item.agent_user_hash,
      'transaction_likelihood_category': item.likelihood_category,
      'transaction_is_cashback': item.is_cashback,
      'transaction_external_id': item.external_transaction_id
    }

    const searchFiltersForSegmentExport = exportSearchFiltersForSegment(
      filterTypeOptions,
      activeFilters,
      { 'agent': item.agent_user_hash }
    )

    segmentEventTracker(eventName,{
      ...baseSegmentProperties,
      ...searchFiltersForSegmentExport,
      ...otherSegmentProperties
    })
  }


  render() {
    const { assignmentList, dispatch, showingReleased, showNote } = this.props

    const renderRow = (assignment) => {
      const relevantDate = showingReleased ? assignment.transaction_status_at : assignment.created_at

      let status
      let subStatus
      let statusDisplay = SHORT_ASSIGNMENT_AGENT_STATUS
      let offersMadeDisplay = AGENT_OFFER_STATUS_SELLING
      let contractDisplay = AGENT_CONTRACT_STATUS
      if (assignment.client_category === 'seller') {
        statusDisplay = SHORT_ASSIGNMENT_AGENT_STATUS_LISTING
        offersMadeDisplay = AGENT_OFFER_STATUS_LISTING
      } else if (assignment.client_category === 'lease-other') {
        statusDisplay = SHORT_ASSIGNMENT_AGENT_STATUS_LEASE
        contractDisplay = AGENT_CONTRACT_STATUS_LEASE
      }
      status = labelFor(statusDisplay, assignment.status)

      if (assignment.network_referral) {
        if (assignment.status === 'confirmed-closed') {
          status = 'Closed'
          subStatus = 'Paid'
        } else {
          status = showingReleased ? 'Released' : 'Referred'
        }
      } else {
        if (assignment.status === 'offers-made') {
          subStatus = labelFor(offersMadeDisplay, assignment.agent_offer_status)
        } else if (assignment.status === 'contract') {
          subStatus = labelFor(contractDisplay, assignment.agent_contract_status)
        } else if (assignment.status === 'closed') {
          status = 'Closed'
          subStatus = 'Awaiting Payment'
        } else if (assignment.status === 'confirmed-closed') {
          status = 'Closed'
          subStatus = 'Paid'
        }
      }

      const leadOwnerWasPaid = assignment.lead_owner_commission_status === LEAD_OWNER_COMMISSION_STATUS.PAID

      const statusPillClasses = "AssignmentTable__block pill " + (assignment.status === "release" ? "pill-danger" : "pill-success")

      return (<tr className={cx(classes, {[assignment.status]: true})} key={assignment.hash}>
        <td>
          { relevantDate && moment.utc(relevantDate).local().format("MM-DD-YY h:mm A") }
        </td>
        <td>
          <div className="AssignmentTable__block">
            <strong>{assignment.override_name ? assignment.override_name : assignment.name}</strong>
          </div>
          <div>{assignment.email}</div>
          <div>{assignment.phone}</div>
          <div>
            { labelFor(BUYER_TYPE, assignment.client_category) }: { assignment.max_budget ? assignment.standard_max_budget : labelFor(DISPLAY_PRICE, assignment.price_category) }
          </div>
          { assignment.broker_is_bla_enabled &&
            <div>Lead Source: {assignment.lead_source_name}</div>
          }

          <div>{labelFor(LEAD_TYPE, assignment.likelihood_category)}</div>

          <div>{assignment.market} {assignment.zipcode}</div>
        </td>
        <td>
          <div className="AssignmentTable__block">
            {!assignment.network_referral ?
              <a onClick={() => {
                this.handleClickForSegmentEvent(assignment, 'Sub-User Masqueraded', {
                  'masqueraded_user_hash': assignment.agent_user_hash
                })

                this.handleViewAgentClick(assignment)
              }}>{ assignment.agent }</a> 
              : <div>{ assignment.agent }</div>
            }
          </div>
          { !assignment.network_referral &&
            <div className="AssignmentTable__block">
              <a href={"mailto:" + assignment.agent_email}>
                <span className="AssignmentTable__email fa fa-envelope"></span>
              </a>

              <span>{ assignment.agent_phone }</span>
            </div>
          }

          { leadOwnerWasPaid &&
            <div>Lead Owner Payment: Paid</div>
          }

          { assignment.agent_terminated_at &&
            <AgentTerminated terminatedAt={assignment.agent_terminated_at} />
          }

          {assignment.lead_owner_commission_confirmed_at ? <div className="Assignment__small">Date Confirmed: {moment(assignment.lead_owner_commission_confirmed_at).utc().local().format("MM/DD/YY")}</div> : null}
        </td>
        <td>
          <div className="Assignment__block"><span className={statusPillClasses}>{ status }</span></div>

          { assignment.agent_close_date &&
            <div>
              <div className="AssignmentTable__projected-close-date">
                <span data-tip="This date has been set by the assigned agent as the closed date within Referral Manager">Projected Close Date:</span>
              </div>
              <div><i className="fa fa-calendar-check-o"/> { assignment.agent_close_date }</div>
            </div>
          }

          <div>{ assignment.agent_last_update_at ? 'Updated ' + assignment.agent_last_update_at : null }</div>
          <div>{ subStatus }</div>

          { assignment.status === "release" ? <div>
              <div>Reason: { labelFor(RELEASE_REASONS, assignment.release_reason) }</div>
            </div>
            : null
          }

          { showNote && assignment.agent_note &&
            <div className="Assignment__note">
              <ShowMore lines={3} more='Show more' less='Show less' anchorClass=''>
                Agent Note: { newlineToBreak(assignment.agent_note) }
              </ShowMore>
            </div>
          }
        </td>
        <td>
          <LeadTypeBadges leadTags={assignment.lead_tags} />

          <div className="AssignmentTable__block">Transaction ID: {assignment.external_transaction_id}</div>

          { assignment.agent_is_holding &&
            <div className="AssignmentTable__danger">On Hold: {assignment.agent_hold_until}</div>
          }

          { assignment.agent_property_address &&
            <div><strong>Property Details:</strong><br/>{ assignment.agent_property_address }</div>
          }

          { assignment.agent_mls &&
            <div>MLS: { assignment.agent_mls }</div>
          }

          { assignment.agent_amount &&
            <div>Home Price: ${ assignment.agent_amount }</div>
          }

          { assignment.agent_close_agent_commission != null &&
            <div>Commission: ${ assignment.agent_close_agent_commission }</div>
          }

          { assignment.transaction_in_review_at &&
            <div className="AssignmentTable__block AssignmentTable__in-review">
              In Review<br/>
              {assignment.transaction_in_review_at}
            </div>
          }

          { leadOwnerWasPaid &&
            <div className="Assignment__small">
              {LEAD_OWNER_LABEL[LEAD_OWNER_TYPE.BROKER]} Comm: ${ assignment.lead_owner_commission_amount || 0 }
            </div>
          }

          { assignment.pdf_url &&
            <div className="AssignmentTable__agreement">
              <a href={assignment.pdf_url} target="_new">Referral agreement</a>
            </div>
          }

          { showNote &&
            <div className={assignment.broker_note ? "Assignment__note Assignment__note--broker" : "AssignmentTable__edit"}>
              { assignment.broker_note &&
                <div>{ newlineToBreak(assignment.broker_note) }<br/><br/></div>
              }
              <div>
                <a onClick={() => {
                  this.handleEditClick(assignment)
                  this.handleClickForSegmentEvent(assignment, 'Modal Shown', {
                    'modal_name': 'ReferralNoteModal | ' + (assignment.broker_note ? 'Edit' : 'Add')
                  })
                }}>
                  { !assignment.broker_note &&
                    <span className="fa fa-plus-circle"></span>
                  }
                  { assignment.broker_note ? " Edit" : " Add Note" }
                </a>
              </div>
            </div>
          }
        </td>
      </tr>)
    }

    const relevantLabel = showingReleased ? <span>Released</span> : <span>Assigned</span>

    return (
      <div className='AssignmentTable'>
        <ReactTooltip/>
        <ReferralNoteModal {...this.props} />
        <Table>
          <thead>
          <tr>
            <th>{relevantLabel}</th>
            <th>Client</th>
            <th>Agent</th>
            <th>Status</th>
            <th>Details</th>
          </tr>
          </thead>
          <tbody>
          { assignmentList ? assignmentList.map(renderRow) : null }
          </tbody>
        </Table>
      </div>
    )
  }

}

export default AssignmentTable
